module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.9901/js/img/OperationsHub_Icon.svg"